// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import pages from './pages';
import pagesSse from './pagesSse';
import mission from './mission';
// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ menu, pages, pagesSse, mission });

export default reducers;
